import React from "react";
import { DatabaseAdmin } from "@rebasepro/types";

export const DatabaseAdminContext = React.createContext<DatabaseAdmin | undefined>(undefined);
